export const isOptgroupSymbol = Symbol('isOptgroup')
export const draggableOptionIdSymbol = Symbol()
